import { App } from 'antd';
import { saveAs } from 'file-saver';
import { useState } from 'react';
import { useObjectUrlResource } from '../../../hooks/useObjectUrlResource.ts';

/** A News attachment in the PDF preview, with the props for PdfPrintPreview. */
export const useAttachmentPreview = () => {
  const { message } = App.useApp();
  const [filename, setFilename] = useState('');
  const { objectUrl, blob, fetchAndSet, cleanup, loading } = useObjectUrlResource(
    () => message.error('Es ist ein Fehler beim Laden des Dokuments aufgetreten'),
    'application/pdf'
  );

  const show = (name: string, url: string) => {
    setFilename(name);
    fetchAndSet(url);
  };

  const preview = {
    title: filename,
    url: objectUrl,
    loading,
    blob,
    onDownload: () => blob && saveAs(blob, filename),
    onClose: () => {
      setFilename('');
      cleanup();
    },
  };

  return { show, preview };
};
